import { API_METHODS } from '@compass/client/constants/api-methods';

import { WorkflowType } from '@/constants/dispositions';
import { useAPIPermission } from '@/hooks/usePermissions';
import { useStore } from '@/store/store';

/**
 * Hook to check if the Campaigns page should be shown in the sidebar.
 * Returns true only when both conditions are met:
 * 1. The user can list campaigns (server permission map). A Case Manager's
 *    map has no ListCampaigns entry, which reads as denied, so the tab is hidden.
 * 2. The selected program has no PQC workflow (Knipper organization) —
 *    campaigns are not applicable for PQC workflows.
 */
export const useShouldShowCampaignsPage = (): boolean => {
  const { getWorkflowsArray } = useStore();
  const workflows = getWorkflowsArray();
  const { hasPermission: canListCampaigns } = useAPIPermission(
    API_METHODS.CampaignService.ListCampaigns,
  );

  // Hide campaigns for PQC workflow (Knipper organization)
  const hasPqcWorkflow =
    workflows?.some(workflow => workflow.workflow_type === WorkflowType.PQC) ?? false;

  return canListCampaigns && !hasPqcWorkflow;
};
